// Campus photo for /colleges/university-at-albany-suny: CC BY 2.0, by Alec Perkins from Hoboken, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASUNY_Albany_(5406832382).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-at-albany-suny/; credited under the photo.
const photo = {
    "slug": "university-at-albany-suny",
    "alt": "Tall concrete columns holding up a flat canopy roof against a blue sky at the University at Albany",
    "src": "/colleges/university-at-albany-suny/campus-1600.webp",
    "srcSmall": "/colleges/university-at-albany-suny/campus-800.webp",
    "srcMid": "/colleges/university-at-albany-suny/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-at-albany-suny/og.jpg",
    "title": "SUNY Albany (5406832382)",
    "author": "Alec Perkins from Hoboken, USA",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASUNY_Albany_(5406832382).jpg",
    "read": "2026-10-01"
};

export default photo;
